<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>年度</td>
                  <td>
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>身分證統一編號</td>
                  <td>
                    <input type="text" v-model="form.idn" />
                  </td>
                  <td>姓名</td>
                  <td>
                    <input type="text" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.doQuery();
                            }
                          "
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table
            width="100%"
            v-if="grid && grid.gridDatas && grid.gridDatas.length > 0"
          >
            <tbody>
              <tr v-if="grid.paginaiton">
                <td>
                  比對年度
                  <select v-model="form.prevSyear" disabled>
                    <option :value="form.prevSyear">
                      {{ form.prevSyear }}
                    </option>
                  </select>
                </td>
                <td align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('DTYPE', Sort);
                          }
                        "
                        >申報種類</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('IDN', Sort);
                          }
                        "
                        >身分證統一編號</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('GOV_CODE', Sort);
                          }
                        "
                        >服務機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('job_gov_code', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('SDATE', Sort);
                          }
                        "
                        >申報基準日</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('DATETIME', Sort);
                          }
                        "
                        >上傳日期</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody
                  v-if="grid && grid.gridDatas && grid.gridDatas.length > 0"
                >
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="比對"
                        :disabled="data.sdate == null"
                        @click="btnModalShow(data)"
                      />
                    </td>
                    <td>{{ data.dtype }}</td>
                    <td>{{ data.name }}</td>
                    <td>
                      <input
                        type="button"
                        class="btn"
                        :value="data.idn"
                        @click="btnA101Detail(data)"
                      />
                    </td>
                    <td>{{ data.goV_CODE_STR }}</td>
                    <td>{{ data.goV_NAME }}</td>
                    <td>{{ data.sdate }}</td>
                    <td>{{ data.datetime }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
    </div>
    <PdisFooter />

    <Modal
      v-model="modal.show"
      :title="modal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>申報人</td>
                <td>{{ modal.grid.name ? modal.grid.name : "" }}</td>
                <td>身分證統一編號</td>
                <td>{{ modal.grid.idn ? modal.grid.idn : "" }}</td>
              </tr>
              <tr>
                <td>職稱</td>
                <td>{{ modal.grid.title ? modal.grid.title : "" }}</td>
                <td>輸出格式</td>
                <td>
                  <label>
                    <input
                      type="radio"
                      v-model="modal.printtype"
                      value="DOCX"
                      checked="checked"
                    />
                    DOCX</label
                  >
                  <label>
                    <input
                      type="radio"
                      v-model="modal.printtype"
                      value="ODT"
                      checked="checked"
                    />
                    ODT</label
                  >
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="button"
                        class="btn"
                        value="存檔"
                        @click="btnModalSave()"
                      />
                      <input
                        type="button"
                        class="btn"
                        value="列印"
                        @click="btnModalPrint()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>

      <div class="information">
        <table width="100%">
          <tbody>
            <tr>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th rowspan="4">申報項目</th>
                  <th>申報年度</th>
                  <th>{{ modal.grid.pyear ? modal.grid.pyear : "" }}</th>
                  <th>申報年度</th>
                  <th>{{ modal.grid.syear ? modal.grid.syear : "" }}</th>
                  <th rowspan="4">比對財產增減情形&nbsp;</th>
                  <th rowspan="4">審核結果</th>
                </tr>
                <tr>
                  <th>申報基準日</th>
                  <th>{{ modal.grid.pdate ? modal.grid.pdate : "" }}</th>
                  <th>申報基準日</th>
                  <th>{{ modal.grid.sdate ? modal.grid.sdate : "" }}</th>
                </tr>
                <tr>
                  <th>申報類別</th>
                  <th>{{ modal.grid.pdtype ? modal.grid.pdtype : "" }}</th>
                  <th>申報類別</th>
                  <th>{{ modal.grid.sdtype ? modal.grid.sdtype : "" }}</th>
                </tr>
                <tr>
                  <th>統計來源</th>
                  <th>{{ modal.grid.pSource ? modal.grid.pSource : "" }}</th>
                  <th>統計來源</th>
                  <th>{{ modal.grid.sSource ? modal.grid.sSource : "" }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>一、土地</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.land ? modal.grid.land.pCount : "0"
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td colspan="2">
                    &nbsp;<span>{{
                      modal.grid.land ? modal.grid.land.sCount : "0"
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td
                    :style="{
                      color: modal.grid.land
                        ? modal.grid.land.pCount != modal.grid.land.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{ modal.grid.land ? modal.grid.land.different : "" }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.landResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>二、建物</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.building ? modal.grid.building.pCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.building ? modal.grid.building.sCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td
                    :style="{
                      color: modal.grid.building
                        ? modal.grid.building.pCount !=
                          modal.grid.building.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{
                      modal.grid.building ? modal.grid.building.different : ""
                    }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.buildingResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>三、船舶</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.vessel ? modal.grid.vessel.pCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.vessel ? modal.grid.vessel.sCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td
                    :style="{
                      color: modal.grid.vessel
                        ? modal.grid.vessel.pCount != modal.grid.vessel.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{ modal.grid.vessel ? modal.grid.vessel.different : "" }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.vesselResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>四、汽車</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.vehicle ? modal.grid.vehicle.pCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.vehicle ? modal.grid.vehicle.sCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td
                    :style="{
                      color: modal.grid.vehicle
                        ? modal.grid.vehicle.pCount != modal.grid.vehicle.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{ modal.grid.vehicle ? modal.grid.vehicle.different : "" }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.vehicleResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>五、航空器</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.aircraft ? modal.grid.aircraft.pCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.aircraft ? modal.grid.aircraft.sCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td
                    :style="{
                      color: modal.grid.aircraft
                        ? modal.grid.aircraft.pCount !=
                          modal.grid.aircraft.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{
                      modal.grid.aircraft ? modal.grid.aircraft.different : ""
                    }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.aircraftResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>六、現金（總額）</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.currency ? modal.grid.currency.pCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.currency ? modal.grid.currency.sCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td
                    :style="{
                      color: modal.grid.currency
                        ? modal.grid.currency.pCount !=
                          modal.grid.currency.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{
                      modal.grid.currency ? modal.grid.currency.different : ""
                    }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.currencyResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>七、存款（總額）</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.deposit ? modal.grid.deposit.pCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.deposit ? modal.grid.deposit.sCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td
                    :style="{
                      color: modal.grid.deposit
                        ? modal.grid.deposit.pCount != modal.grid.deposit.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{ modal.grid.deposit ? modal.grid.deposit.different : "" }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.depositResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>八、有價證券（總額）</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.stock ? modal.grid.stock.pCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.stock ? modal.grid.stock.sCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td
                    :style="{
                      color: modal.grid.stock
                        ? modal.grid.stock.pCount != modal.grid.stock.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{ modal.grid.stock ? modal.grid.stock.different : "" }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.stockResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>九、</span>其他財產<br />
                    <span>1.珠寶、古董、字畫及其他具有相當價值之財產</span>
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.otherProperty
                        ? modal.grid.otherProperty.pCount
                        : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.otherProperty
                        ? modal.grid.otherProperty.sCount
                        : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td
                    :style="{
                      color: modal.grid.otherProperty
                        ? modal.grid.otherProperty.pCount !=
                          modal.grid.otherProperty.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{
                      modal.grid.otherProperty
                        ? modal.grid.otherProperty.different
                        : ""
                    }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.otherPropertyResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>2.保險</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.insurance ? modal.grid.insurance.pCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.insurance ? modal.grid.insurance.sCount : ""
                    }}</span
                    >&nbsp;筆
                  </td>
                  <td
                    :style="{
                      color: modal.grid.insurance
                        ? modal.grid.insurance.pCount !=
                          modal.grid.insurance.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{
                      modal.grid.insurance ? modal.grid.insurance.different : ""
                    }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.insuranceResult"
                    ></textarea>
                  </td>
                </tr>
                <tr v-show="modal.showVirtualAssets">
                  <td>3.虛擬資產</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.virtualAssets ? modal.grid.virtualAssets.pCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.virtualAssets ? modal.grid.virtualAssets.sCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td
                    :style="{
                      color: modal.grid.virtualAssets
                        ? modal.grid.virtualAssets.pCount !=
                          modal.grid.virtualAssets.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{
                      modal.grid.virtualAssets ? modal.grid.virtualAssets.different : ""
                    }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.virtualAssetsResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>十、債權（總額）</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.claim ? modal.grid.claim.pCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.claim ? modal.grid.claim.sCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td
                    :style="{
                      color: modal.grid.claim
                        ? modal.grid.claim.pCount != modal.grid.claim.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{ modal.grid.claim ? modal.grid.claim.different : "" }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.claimResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>十一、債務（總額）</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.debt ? modal.grid.debt.pCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.debt ? modal.grid.debt.sCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td
                    :style="{
                      color: modal.grid.debt
                        ? modal.grid.debt.pCount != modal.grid.debt.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{ modal.grid.debt ? modal.grid.debt.different : "" }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.debtResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>十二、事業投資（總額）</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.investment ? modal.grid.investment.pCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.investment ? modal.grid.investment.sCount : ""
                    }}</span
                    >&nbsp;元
                  </td>
                  <td
                    :style="{
                      color: modal.grid.investment
                        ? modal.grid.investment.pCount !=
                          modal.grid.investment.sCount
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{
                      modal.grid.investment
                        ? modal.grid.investment.different
                        : ""
                    }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.investmentResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>十三、備註</td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.remark ? modal.grid.remark.pRemark : ""
                    }}</span>
                  </td>
                  <td colspan="2">
                    <span>{{
                      modal.grid.remark ? modal.grid.remark.sRemark : ""
                    }}</span>
                  </td>
                  <td
                    :style="{
                      color: modal.grid.remark
                        ? modal.grid.remark.pRemark != modal.grid.remark.sRemark
                          ? 'red'
                          : 'black'
                        : 'black',
                    }"
                  >
                    {{ modal.grid.remark ? modal.grid.remark.different : "" }}
                  </td>
                  <td>
                    <textarea
                      rows="5"
                      cols="40"
                      v-model="modal.form.remarkResult"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td colspan="7">
                    請參照N104財稅資料查詢。<br />
                    全年薪資所得係指職務上或工作上所取得之薪金、俸給、工資、津貼、歲費、獎金、紅利及補助費等各種薪資收入。
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center">
            <input
              type="button"
              class="btn"
              value="存檔"
              @click="btnModalSave()"
            />
            <input
              type="button"
              class="btn"
              value="列印"
              @click="btnModalPrint()"
            />
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </Modal>

    <A101DetailModal
      v-model="A101DetailModal.show"
      :title="A101DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>服務機關</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.jobGovCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode2"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode3"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.govCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode2"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode3"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號/居留證號</td>
                <td>
                  <input
                    type="text"
                    maxlength="20"
                    v-model="A101DetailModal.form.idn"
                    disabled
                  />
                </td>
                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.name"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>生日</td>
                <td colspan="3">
                  <DatePicker
                    v-model="A101DetailModal.form.birthday"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>單位及職稱</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.title"
                    disabled
                  />
                </td>
                <td>階級</td>
                <td>
                  <select v-model="A101DetailModal.form.rank" disabled>
                    <option value="">無</option>
                    <option value="1">上將</option>
                    <option value="2">中將</option>
                    <option value="3">少將</option>
                    <option value="4">上校</option>
                    <option value="5">中校</option>
                    <option value="6">少校</option>
                    <option value="7">上尉</option>
                    <option value="8">中尉</option>
                    <option value="9">少尉</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>聯絡電話</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.tel"
                    size="20"
                    maxlength="20"
                    disabled
                  />
                </td>
                <td>E-Mail</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.email"
                    size="20"
                    maxlength="40"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker
                    v-model="A101DetailModal.form.arriveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
                <td>去職日</td>
                <td>
                  <DatePicker
                    v-model="A101DetailModal.form.leaveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>現職狀況</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.leave"
                    style="min-width: 480px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .onJobs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>應申報身分資格</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.status"
                    style="max-width: 1000px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .OnDeclare"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="A101DetailModal.form.leave_Reason"
                      size="80"
                      maxlength="80"
                      disabled
                    />
                    <br />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </A101DetailModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  SearchGridOnJob,
  SearchGridOnDeclare,
  A101_DetailInit,
  F202_SearchGrid,
  F202_ReSearchGrid,
  F202_SearchGrid2,
  F202_updateVerifyResult,
  F202_printVerifyResult,
} from "@/service/api.js";
export default {
  name: "F202",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F202",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        idn: "",
        name: "",
        syear: String(new Date().getFullYear() - 1911 - 1),
        prevSyear: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        syears: [],
      },
      grid: {},
      modal: {
        show: false,
        showVirtualAssets: false,
        title: "N102前後年度申報財產比對-跨年度審核作業比對表",
        form: {
          landResult: "",
          buildingResult: "",
          vesselResult: "",
          vehicleResult: "",
          aircraftResult: "",
          currencyResult: "",
          depositResult: "",
          stockResult: "",
          otherPropertyResult: "",
          insuranceResult: "",
          claimResult: "",
          debtResult: "",
          investmentResult: "",
          remarkResult: "",
          virtualAssetsResult: "",
        },
        grid: {},
        PreData: {},
        printtype: "DOCX",
      },
      A101DetailModal: {
        show: false,
        title: "A101申報人基本資料",
        form: {
          govCode1: "",
          govCode2: "",
          govCode3: "",
          govCode4: "",
          jobGovCode1: "",
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          idn: "",
          name: "",
          birthday: "",
          title: "",
          rank: "",
          tel: "",
          email: "",
          arriveDate: "",
          leaveDate: "",
          //現職狀況
          leave: "",
          //應申報身分資格
          status: "",
          //備註
          leave_Reason: "",
        },
        modifyType: "", //"I,U"
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          OnDeclare: [],
          onJobs: [],
        },
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Modal: VueModal,
    A101DetailModal: VueModal,
    DatePicker: VueDatepicker,
    Alert: VueModal,
  },
  methods: {
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    getSyearDropDownList: function () {
      let syears = [];
      for (
        let i = new Date().getFullYear() - 1911;
        i > new Date().getFullYear() - 1911 - 4;
        i--
      ) {
        syears.push(i.toString());
      }
      return syears;
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        goV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        govcheck: self.form.jobGovCheck,
        SYEAR: self.form.syear,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      F202_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
          self.form.prevSyear = String(parseInt(self.form.syear) - 1);
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        goV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        govcheck: self.form.jobGovCheck,
        SYEAR: self.form.syear,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      console.log(JSON.stringify(postData));
      F202_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
          self.form.prevSyear = String(parseInt(self.form.syear) - 1);
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁重填
    btnClear: function () {
      const self = this;
      self.form = {
        idn: "",
        name: "",
        syear: String(new Date().getFullYear() - 1911 - 1),
        prevSyear: "",
        govCheck: "0",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        pagesize: 10,
        currentpage: 1,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    //第一頁按紐比對
    btnModalShow: function (data) {
      const self = this;
      self.modal.PreData = data;
      self.modal.grid = {};
      self.F202_SearchGrid2();
      self.modal.show = true;
    },
    //第二頁比對資料內容 API
    F202_SearchGrid2: function () {
      const self = this;
      let postData = {
        idn: self.modal.PreData.idn,
        name: self.modal.PreData.name,
        goV_CODE: self.modal.PreData.goV_CODE,
        syear: self.modal.PreData.syear,
        pyear: String(self.modal.PreData.syear - 1),
        verifySeq: self.modal.PreData.verifySeq,
        printtype: self.modal.printtype,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "比對",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      F202_SearchGrid2(postData).then((rData) => {
        self.modal.grid = rData.returnObject;
        if (parseInt(self.modal.grid.sdatetime) >= 1120901) {
          self.modal.showVirtualAssets = true;
        }
        else {
          self.modal.showVirtualAssets = false;
        }
        self.modal.form = {
          landResult: self.modal.grid.land
            ? self.modal.grid.land.verifyResult
            : "",
          buildingResult: self.modal.grid.building
            ? self.modal.grid.building.verifyResult
            : "",
          vesselResult: self.modal.grid.vessel
            ? self.modal.grid.vessel.verifyResult
            : "",
          vehicleResult: self.modal.grid.vehicle
            ? self.modal.grid.vehicle.verifyResult
            : "",
          aircraftResult: self.modal.grid.aircraft
            ? self.modal.grid.aircraft.verifyResult
            : "",
          currencyResult: self.modal.grid.currency
            ? self.modal.grid.currency.verifyResult
            : "",
          depositResult: self.modal.grid.deposit
            ? self.modal.grid.deposit.verifyResult
            : "",
          stockResult: self.modal.grid.stock
            ? self.modal.grid.stock.verifyResult
            : "",
          otherPropertyResult: self.modal.grid.otherProperty
            ? self.modal.grid.otherProperty.verifyResult
            : "",
          insuranceResult: self.modal.grid.insurance
            ? self.modal.grid.insurance.verifyResult
            : "",
          claimResult: self.modal.grid.claim
            ? self.modal.grid.claim.verifyResult
            : "",
          debtResult: self.modal.grid.debt
            ? self.modal.grid.debt.verifyResult
            : "",
          investmentResult: self.modal.grid.investment
            ? self.modal.grid.investment.verifyResult
            : "",
          remarkResult: self.modal.grid.remark
            ? self.modal.grid.remark.verifyResult
            : "",
          virtualAssetsResult: self.modal.grid.virtualAssets
            ? self.modal.grid.virtualAssets.verifyResult
            : "",
        };
      });
    },
    //第二頁存檔
    btnModalSave: function () {
      const self = this;
      let postData = {
        verifyYearSeq: self.modal.grid.verifyYearSeq,
        landResult: self.modal.form.landResult,
        buildingResult: self.modal.form.buildingResult,
        vesselResult: self.modal.form.vesselResult,
        vehicleResult: self.modal.form.vehicleResult,
        aircraftResult: self.modal.form.aircraftResult,
        currencyResult: self.modal.form.currencyResult,
        depositResult: self.modal.form.depositResult,
        stockResult: self.modal.form.stockResult,
        otherPropertyResult: self.modal.form.otherPropertyResult,
        insuranceResult: self.modal.form.insuranceResult,
        claimResult: self.modal.form.claimResult,
        debtResult: self.modal.form.debtResult,
        investmentResult: self.modal.form.investmentResult,
        remarkResult: self.modal.form.remarkResult,
        virtualAssetsResult: self.modal.form.virtualAssetsResult,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      F202_updateVerifyResult(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["存檔成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["存檔失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁列印
    btnModalPrint: function () {
      const self = this;
      let postData = {
        idn: self.modal.PreData.idn,
        name: self.modal.PreData.name,
        goV_CODE: self.modal.PreData.goV_CODE,
        syear: self.modal.PreData.syear,
        pyear: String(self.modal.PreData.syear - 1),
        verifySeq: self.modal.PreData.verifySeq,
        printtype: self.modal.printtype,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "列印",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      F202_printVerifyResult(postData).then((rData) => {
        if (self.modal.printtype == "ODT") {
          let link = document.createElement("a");
          link.download = "跨年度財申審核作業比對表.odt";
          //docx;
          //link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + rData;
          //link.href = "data:application/pdf;base64," + rData;
          link.href = "data:application/doc;base64," + rData;
          link.click();
        } else {
          let link = document.createElement("a");
          link.download = "跨年度財申審核作業比對表.docx";
          //docx;
          //link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + rData;
          //link.href = "data:application/pdf;base64," + rData;
          link.href = "data:application/doc;base64," + rData;
          link.click();
        }
      });
    },
    //A101明細
    btnA101Detail: function (data) {
      const self = this;
      self.A101DetailModal.form = {
        //取得Radmin_Rel內
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        idn: "",
        name: "",
        birthday: "",
        title: "",
        rank: "",
        tel: "",
        email: "",
        arriveDate: "",
        leaveDate: "",
        //現職狀況
        leave: "",
        //應申報身分資格
        status: "",
        //備註
        leave_Reason: "",
      };
      self.A101DetailModal.PreData = data;
      self.getA101DetailData(data);

      self.A101DetailModal.modifyType = "U";
      self.A101DetailModal.title = "A101申報人基本資料維護-明細";
      self.A101DetailModal.show = true;
    },
    //A101明細 API
    getA101DetailData: function (data) {
      const self = this;
      A101_DetailInit({ idn: data.idn, goV_CODE: data.goV_CODE }).then(
        (rData) => {
          if (rData.result) {
            self.A101DetailModal.grid = rData.returnObject;
            self.A101DetailModal.form = {
              //取得Radmin_Rel內
              govCode1: self.A101DetailModal.grid.r_GovCodeStr.split(",")[0],
              govCode2: self.A101DetailModal.grid.r_GovCodeStr.split(",")[1],
              govCode3: self.A101DetailModal.grid.r_GovCodeStr.split(",")[2],
              govCode4: self.A101DetailModal.grid.r_GovCodeStr.split(",")[3],
              jobGovCode1:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[0],
              jobGovCode2:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[1],
              jobGovCode3:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[2],
              jobGovCode4:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[3],
              idn: self.A101DetailModal.grid.idn,
              name: self.A101DetailModal.grid.name,
              birthday: self.A101DetailModal.grid.birthday,
              title: self.A101DetailModal.grid.title,
              rank: self.A101DetailModal.grid.rank,
              tel: self.A101DetailModal.grid.tel,
              email: self.A101DetailModal.grid.email,
              arriveDate: self.A101DetailModal.grid.arriveDate,
              leaveDate: self.A101DetailModal.grid.leaveDate,
              //現職狀況
              leave: self.A101DetailModal.grid.leave,
              //應申報身分資格
              status: self.A101DetailModal.grid.status,
              //備註
              leave_Reason: self.A101DetailModal.grid.leaveReason,
            };
          } else {
            self.A101DetailModal.show = false;

            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [
              "未取得資料，請至A101確認此[身分證統一編號][受理申報機關]是否有資料",
            ];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
          self.A101DetailModalInit();
        }
      );
    },
    A101DetailModalInit: function () {
      const self = this;
      self.modalGetA101SearchGovCode1();
      self.modalGetA101SearchGovCode2();
      self.modalGetA101SearchGovCode3();
      self.modalGetA101SearchGovCode4();
      self.modalGetA101OnDeclare();
      self.modalGetA101OnJob();
    },
    //A101明細取得服務機關第一層類別 DetailModal
    modalGetA101SearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.A101DetailModal.dropDownList.govCode1s = rData.returnObject;
        self.A101DetailModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //A101明細取得服務機關第二層類別 DetailModal
    modalGetA101SearchGovCode2: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode1 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode1,
          LAYER_NUM: "2",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode2s = rData.returnObject;
          self.A101DetailModal.form.govCode2 =
            self.A101DetailModal.form.govCode2;
        });
      }
      if (self.A101DetailModal.form.jobGovCode1 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode1,
          LAYER_NUM: "2",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode2s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode2 =
            self.A101DetailModal.form.jobGovCode2;
        });
      }
    },
    //A101明細取得服務機關第三層類別 DetailModal
    modalGetA101SearchGovCode3: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode2 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode2,
          LAYER_NUM: "3",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode3s = rData.returnObject;
          self.A101DetailModal.form.govCode3 =
            self.A101DetailModal.form.govCode3;
        });
      }
      if (self.A101DetailModal.form.jobGovCode2 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode2,
          LAYER_NUM: "3",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode3s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode3 =
            self.A101DetailModal.form.jobGovCode3;
        });
      }
    },
    //A101明細取得服務機關第四層類別 DetailModal
    modalGetA101SearchGovCode4: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode3 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode3,
          LAYER_NUM: "4",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode4s = rData.returnObject;
          self.A101DetailModal.form.govCode4 =
            self.A101DetailModal.form.govCode4;
        });
      }
      if (self.A101DetailModal.form.jobGovCode3 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode3,
          LAYER_NUM: "4",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode4s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode4 =
            self.A101DetailModal.form.jobGovCode4;
        });
      }
    },
    //A101取得申報身分資格 DetailModal
    modalGetA101OnDeclare: function () {
      const self = this;
      SearchGridOnDeclare({}).then((rData) => {
        self.A101DetailModal.dropDownList.OnDeclare = [
          { mcode: "", mvalue: "" },
        ].concat(rData.returnObject);
      });
    },
    //A101取得在職狀態 GovCodeModal
    modalGetA101OnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.A101DetailModal.dropDownList.onJobs = [
          { value: "", text: "" },
        ].concat(rData.returnObject);
      });
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
  created() {
    const self = this;
    //教育部的部分新系統後台請維持先前作法，以系統寫死六組之方式
    if(self.loginInfo && self.loginInfo.govCodeStr.split(',')[0] === '309000000E'){
      switch(self.loginInfo.govCode)
      {
        case "309000000E":
        case "309000100E":
        case "A09000000E":
        case "A09010000E":
        case "A09020000E":
        case "309130000E":
        case "309190000E":
          break;
        default:
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.$router.go(-1);
          };
          break;
      }
    }
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.JobGovCodeInit(self.form);
    self.getSearchJobGovCode1();
    self.dropDownList.syears = self.getSyearDropDownList();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
